module.exports = __webpack_public_path__ + "p.no1.7aa12989.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/p.no1.jpg
// module id = zTri
// module chunks = 0